import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, ReactNode, useEffect, useState } from "react";
import theme from "../../theme";
import {
  PasswordEyeIcon,
  PasswordEyeIconOff,
} from "../../assets/Icon/singUpIcon";
import { StyledErrorMessage } from "../style/modalStyle";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
interface InputProps {
  placeholder: string;
  icon?: ReactNode;
  type?: string;
  minWidth?: string;
  formik?: any;
  margin?: "dense" | "normal" | "none";
  name?: string;
  isPhnNo?: boolean;
  label?: string;
  isSelect?: boolean;
  isMulti?: boolean;
  isZipCode?: boolean;
  disabled?: boolean;
  labelFontSize?: string;
  showBorder?: boolean; // New prop for always showing border
  maxLength?: number;
  rows?: number;
  borderSize?: string;
  borderRadius?: string;
  pattern?: string;
  onInput?: () => void;
  numericOnly?: boolean;
  noDecimal?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  phoneName?: string;
  countryCodeName?: string;
}
const FormInputField: React.FC<InputProps> = ({
  isPhnNo,
  placeholder,
  numericOnly,
  onInput,
  noDecimal,
  icon,
  type,
  borderRadius,
  borderSize,
  rows,
  name,
  pattern,
  minWidth,
  label,
  formik,
  isMulti,
  disabled,
  margin,
  isSelect,
  isZipCode,
  labelFontSize,
  maxLength,
  showBorder = false, // Default to false
  onChange,
  phoneName,
  countryCodeName,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    formik.setFieldValue(name, e.target.value);
  };

  const [phoneValue, setPhoneValue] = useState<string>("");

  const phoneFieldName = phoneName || "phone_number";
  const countryCodeFieldName = countryCodeName || "country_code";

  useEffect(() => {
    const cCode = formik.values[countryCodeFieldName];
    const pNum = formik.values[phoneFieldName];
    if (cCode || pNum) {
      setPhoneValue(`${cCode || ""}${pNum || ""}`);
    } else {
      setPhoneValue("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    formik.values[countryCodeFieldName],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    formik.values[phoneFieldName],
    countryCodeFieldName,
    phoneFieldName,
  ]);

  const handleNumericKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowed = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
    const isDigit = /\d/.test(e.key);
    const isDot = e.key === ".";
    if (
      !allowed.includes(e.key) &&
      !isDigit &&
      // allow dot only if numericOnly && !noDecimal
      !(isDot && numericOnly && !noDecimal)
    ) {
      e.preventDefault();
    }
    // prevent second dot
    if (isDot && e.currentTarget.value.includes(".")) {
      e.preventDefault();
    }
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    // Prevent scrolling from changing number input values
    if (type === "number") {
      e.currentTarget.blur();
    }
  };

  const handleNumericInput = (e: React.FormEvent<HTMLInputElement>) => {
    let val = e.currentTarget.value;
    // strip everything except digits (and dot if allowed)
    const regex = noDecimal ? /[^0-9]/g : /[^0-9.]/g;
    val = val.replace(regex, "");
    // if decimals allowed, keep only first dot + following
    if (!noDecimal) {
      const [intPart, fracPart] = val.split(".");
      val = fracPart != null ? `${intPart}.${fracPart}` : intPart;
    }
    e.currentTarget.value = val;
    formik.setFieldValue(name!, val);
  };

  return (
    <>
      <Typography
        sx={{
          color: theme.palette.myCustomColor.dark,
          whiteSpace: "wrap",
          wordBreak: "break-word",
        }}
        variant="h4"
        fontSize={labelFontSize}
      >
        {label}
      </Typography>

      {isPhnNo ? (
        <PhoneInput
          country={"us"}
          value={phoneValue}
          disabled={disabled}
          onChange={(value: string, data: any) => {
            setPhoneValue(value);
            const countryCode = `+${data.dialCode}`;
            const digits = value.replace(/\D/g, "");
            const phoneNumber = digits.startsWith(data.dialCode)
              ? digits.slice(data.dialCode.length)
              : digits;

            formik.setFieldValue(countryCodeFieldName, countryCode);
            formik.setFieldValue(phoneFieldName, phoneNumber);
          }}
          inputProps={{
            name: "phone",
            autoComplete: "off",
            onBlur: () => {},
            onKeyDown: (event: any) => {
              const dialCode =
                formik.values[countryCodeFieldName]?.replace("+", "") || "1";
              const cursorPos = event.target.selectionStart;
              const minCursorPos = dialCode.length + 1;

              if (event.key === "Backspace" && cursorPos <= minCursorPos) {
                event.preventDefault();
              }
            },
          }}
          containerStyle={{
            marginTop: "10px",
            width: "100%",
            borderRadius: "8px",
          }}
          inputStyle={{
            width: "100%",
            minHeight: "54px",
            paddingLeft: "60px",
            fontSize: "16px",
            color: "#2C3034",
            fontWeight: 400,
            border: disabled
              ? "none"
              : formik.errors.phone_number &&
                  (formik?.touched[name ?? ""] || formik.submitCount > 0)
                ? "1px solid #D32F2F"
                : showBorder
                  ? `${borderSize || "1px"} solid #A7C7EA`
                  : "1px solid transparent",
            outline: "none",
            backgroundColor: "white",
            borderRadius: "4px",
          }}
          buttonStyle={{
            backgroundColor: "#ffffff",
            border: "none",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
            borderRight: "1px solid #E6E7EA",
            margin: "10px",
            paddingRight: "10px",
          }}
          dropdownStyle={{
            borderRadius: "8px",
            marginTop: "25px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          }}
        />
      ) : (
        // <PhoneInput
        //   country={"us"}
        //   disabled={disabled}
        //   // value={formik.values.phone_number ? formik.values.phone_number : ""}
        //   value={
        //     formik.values.country_code && formik.values.phone_number
        //       ? `${formik.values.country_code}${formik.values.phone_number}`.replace(/\s+/g, "")
        //       : ""
        //   }

        //   onChange={(value: string, data: any) => {
        //     if (!value) {
        //       formik.setFieldValue("country_code", "+1");
        //       formik.setFieldValue("phone_number", "");
        //       formik.setFieldTouched(name, true);
        //       return;
        //     }

        //     const countryCode = `+${data.dialCode}`; // e.g., "+380"

        //     let rawValue = value.replace(/\D/g, ""); // remove non-digits
        //     const dialCode = data.dialCode; // e.g., "380"

        //     let phoneNumber = rawValue.startsWith(dialCode)
        //       ? rawValue.slice(dialCode.length)
        //       : rawValue;

        //     formik.setFieldValue("country_code", countryCode); // "+380"
        //     formik.setFieldValue("phone_number", phoneNumber); // "454657658"
        //     // formik.setFieldTouched(name, true);

        //   }}
        //   inputProps={{
        //     name: "phone",
        //     autoComplete: "off",
        //     onBlur: () => {
        //       // Do not trigger validation here
        //     },
        //     onKeyDown: (event: any) => {
        //       if (event.key === "Backspace" && !formik.values.phone_number) {
        //         formik.setFieldValue("country_code", "+1");
        //       }
        //     },
        //   }}
        //   containerStyle={{
        //     marginTop: "10px",
        //     width: "100%",
        //     borderRadius: "8px",
        //   }}
        //   inputStyle={{
        //     width: "100%",
        //     minHeight: "54px",
        //     paddingLeft: "60px",
        //     fontSize: "16px",
        //     color: "#2C3034",
        //     fontWeight: 400,
        //     border:
        //       formik.errors.phone_number &&
        //       formik?.touched[name ?? ""] &&
        //       formik.submitCount > 0
        //         ? "1px solid #D32F2F"
        //         : "1px solid transparent",
        //     outline: "none",
        //     backgroundColor: "white",
        //     borderRadius: "4px",
        //   }}
        //   buttonStyle={{
        //     backgroundColor: "#ffffff",
        //     border: "none",
        //     borderTopLeftRadius: "8px",
        //     borderBottomLeftRadius: "8px",
        //     borderRight: "1px solid #E6E7EA",
        //     margin: "10px",
        //     paddingRight: "10px",
        //   }}
        //   dropdownStyle={{
        //     borderRadius: "8px",
        //     marginTop: "25px",
        //     backgroundColor: "#FFFFFF",
        //     boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        //   }}
        // />
        <TextField
          // variant="outlined"
          name={name} // ✅ Make sure 'name' is correctly passed
          type={type ? type : "text"}
          disabled={disabled}
          placeholder={placeholder}
          margin="dense"
          multiline={isMulti}
          rows={isMulti ? rows : 0}
          onChange={(e) => (onChange ? onChange(e) : handleChange(e))}
          value={formik?.values[name ?? ""]}
          error={
            !!(
              formik?.errors[name ?? ""] &&
              (formik?.touched[name ?? ""] || formik?.submitCount > 0)
            )
          }
          // inputProps={{ maxLength: maxLength }}

          inputProps={{
            maxLength,
            ...(numericOnly && {
              inputMode: "decimal",
              pattern: noDecimal ? "[0-9]*" : "[0-9]*\\.?[0-9]*",
              onKeyDown: handleNumericKeyDown,
              onInput: handleNumericInput,
            }),
            ...(type === "number" && {
              onWheel: handleWheel,
            }),
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
              endAdornment: type === "password" && (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePassword} edge="end">
                    {showPassword ? (
                      <PasswordEyeIcon />
                    ) : (
                      <PasswordEyeIconOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
              style: {
                fontSize: "16px",
                fontWeight: 400,
                color: "#2C3034",
                width: "100%",
              },
            },
          }}
          sx={{
            // ✅ Remove number input arrows
            "& input[type=number]": {
              MozAppearance: "textfield",
            },
            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
              {
                WebkitAppearance: "none",
                margin: 0,
              },

            width: "100%",

            boxShadow: "0px 4px 40px 0px #D1DEEB33 ",
            "& .MuiOutlinedInput-root": {
              borderRadius: borderRadius || "4px", // <-- Apply borderRadius here

              "& fieldset": {
                border: disabled
                  ? "none"
                  : showBorder
                    ? `${borderSize || "1px"} solid #A7C7EA`
                    : `${borderSize || "1px"} solid transparent`,
              },
              "&:hover fieldset": {
                border: disabled
                  ? "none"
                  : `${borderSize || "1px"} solid #A7C7EA`,
              },
              "&.Mui-focused fieldset": {
                border: disabled
                  ? "none"
                  : `${borderSize || "0.5px"} solid #A7C7EA`,
              },
              "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
                opacity: 1,
                WebkitTextFillColor: "inherit",
              },
            },
          }}
        />
      )}

      <StyledErrorMessage>
        {formik?.errors[name ?? ""] &&
          (formik?.touched[name ?? ""] || formik?.submitCount > 0) &&
          formik?.errors[name ?? ""]}
        {/* {formik?.errors[name ?? ""] &&
          formik?.touched[name ?? ""] &&
          formik?.errors[name ?? ""]} */}
      </StyledErrorMessage>
    </>
  );
};

export default FormInputField;
